import styled from "styled-components";

export const Wrap = styled.div`
  display: flex;
  /* align-items: center; */
  padding: 50px 225px 127px 225px;
  background: #e5e5e5;
`;

Wrap.Sign = styled.div`
  flex: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e6e9ec;
  box-shadow: 0px 10px 30px rgba(13, 38, 59, 0.05);
  border-radius: 3px;
  height: fit-content;
  padding: 27px 30px 35px 30px;
`;

Wrap.Register = styled.div`
  display: flex;
  flex: 1;
  background: #fff;
  padding: 27px 30px 35px 30px;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e6e9ec;
  box-shadow: 0px 10px 30px rgba(13, 38, 59, 0.05);
  border-radius: 3px;
  height: fit-content;
  margin-left: 20px;
`;

Wrap.Title = styled.h1`
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  color: #0d263b;
  padding-bottom: 34px;
`;

Wrap.SubTitle = styled.h3`
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  color: #0d263b;
  padding-bottom: 8px;
`;

Wrap.Input = styled.input`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #0d263b;
  border: none;
  border-bottom: 2px solid #e6e9ec;
  margin-bottom: 40px;
  outline: none;
  padding-bottom: 8px;
  position: relative;
`;

Wrap.Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 55px;
  background: ${({ bg }) => (bg ? bg : " #0061df")};
  margin-top: 30px;
  border-radius: 3px;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  text-transform: uppercase;
  color: #ffffff;
  cursor: pointer;
`;

Wrap.ReEnter = styled.div`
  position: absolute;
  display: block;
  bottom: 15px;
  color: red;
  z-index: 10;
`;
Wrap.Remember = styled.div`
  display: flex;
  align-items: center;

  a {
    margin-left: auto;
  }
  label {
    margin-left: 12px;
    cursor: pointer;
  }
  input {
    background: #ffffff;
    border: 2px solid #e6e9ec;
    width: 18px;
    cursor: pointer;
    height: 18px;
  }
`;
Wrap.UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  background: #f6f8f9;
  border-radius: 3px;
  margin: 24px 30px;
  padding: 24px 30px;
`;
